import moment from "moment";

const YMD = "YYYY-MM-DD";
const YMDHM = "YYYY-MM-DD HH:mm a";
const MDYHMA = "M/D/YY h:mmA";
const MDY4 = "MM/DD/YYYY";
const weeklyPlanningFormat = "dddd, MM.DD.YYYY";
const VALID_DATE_FORMAT_LIST = ["MM/D/YYYY", "M/D/YYYY"];

const verifyDate = s => {
  if (!s) return null;
  const test = moment(s, VALID_DATE_FORMAT_LIST);
  return test.isValid() ? test : null;
};

export default {
  YMD: YMD,
  YMDHM: YMDHM,
  MDYHMA: MDYHMA,
  MDY4: MDY4,
  localDateTime(utcDateTime) {
    if (!utcDateTime) {
      return null;
    }
    return moment
      .utc(utcDateTime, "YYYY-M-DTh:mm:ss.SS")
      .local()
      .format(MDYHMA);
  },
  isDateValid(dateString) {
    return verifyDate(dateString) !== null;
  },
  parseDatePickerDate(s, fmt = YMD) {
    const validated = verifyDate(s);
    if (validated) {
      return validated.format(fmt);
    } else {
      return s;
    }
  },
  getSelectedDate(date, fmt = null) {
    if (date) {
      return fmt ? moment(date).format(fmt) : moment(date);
    }
    return null;
  },
  momentFromString(date, fmt = null) {
    if (fmt) {
      return moment(date, fmt, true);
    }
    if (date) {
      return moment(date);
    }
    return null;
  },
  getStringFromMoment(m, f = null) {
    if (m) {
      if (f) {
        return m.format(f);
      } else {
        return m.format(YMD);
      }
    }
    return null;
  },
  last7Days() {
    var result = [];
    for (var i = 0; i < 7; i++) {
      var d = new Date();
      d.setDate(d.getDate() - i);
      result.push(this.getSelectedDate(d, MDY4));
    }
    return result;
  },
  formatStringDate(dateString, fmt = MDY4) {
    let date = this.momentFromString(dateString);
    return this.getStringFromMoment(date, fmt);
  },
  getPlanningWeekRange(selectedDate) {
    var datesList = [];
    var firstDay = "";
    var lastDay = "";
    var firstDate = selectedDate.getDate() - selectedDate.getDay(); //get sundays date
    var day = this.momentFromString(
      new Date(selectedDate.setDate(firstDate + 1))
    ).utc();
    for (var d = 1; d < 6; d++) {
      var weekDay = this.getStringFromMoment(day, weeklyPlanningFormat);
      datesList.push(weekDay);
      if (d === 1) {
        firstDay = this.getStringFromMoment(day);
      }
      if (d === 5) {
        lastDay = this.getStringFromMoment(day);
      }
      day.add(1, "days");
    }
    return { list: datesList, startDate: firstDay, endDate: lastDay };
  },

  formatDateForServer(dateString) {
    var date = this.momentFromString(dateString);
    return this.getStringFromMoment(date);
  },
  getUtcDate() {
    return moment().toDate();
  },

  setDefaultShippingDate() {
    var d = moment()
      .subtract(1, "days")
      .toDate();
    return d;
  }
};



// WEBPACK FOOTER //
// ./src/helpers/dateHelper.js